import React from 'react';
import { Link } from 'react-router';

import { data as paymentDataPropTypes } from '../paymentPropTypes.js';
import formatOreToKroner from '../../lib/formatOreToKroner.js';

const SuggestDifferentResolution = ({ payment }) => (
    <div>
        <p>
            Du godtok ikke prisavslaget på {formatOreToKroner(payment.discount)}.
            Hvilken løsning ønsker du å foreslå i stedet?
        </p>

        <div className="centerify">
            <div className="r-phl r-ptl">
                <Link className="button fullwidth" to="/losning/foresla-avslag">
                    Foreslå et annet prisavslag
                </Link>

                <div className="mtl">
                    <a
                        target="_blank"
                        href="https://hjelpesenter.finn.no/hc/no/articles/115001246405/"
                    >
                        Les mer om prisavslag og retur
                    </a>
                </div>
            </div>
        </div>
    </div>
);

SuggestDifferentResolution.propTypes = {
    payment: paymentDataPropTypes.isRequired,
};

export default SuggestDifferentResolution;



// WEBPACK FOOTER //
// ./safeTrade/resolution/suggestDifferentResolution.jsx